(function() {
	// eslint-disable-next-line no-undef
	angular.module('meanApp').factory('ingredientsManager', ingredientsManager);

	ingredientsManager.$inject = [ 'Ingredient', 'modelManager', 'httpAuth', '$q' ];
	function ingredientsManager(Ingredient, modelManager, httpAuth, $q) {
		// eslint-disable-next-line no-undef
		return angular.extend(
			{
				//TODO later array of search texts ?? for now on just one word
				search: function(text) {
					var deferred = $q.defer();
					httpAuth
						.get('/api/ingredients/?search=' + encodeURI(text))
						.success(function(ingredientsArray) {
							/**var users = []; 
                    usersArray.docs.forEach(function(userData) {
                        console.log(userData);
                        var user = scope._retrieveInstance(userData._id, userData);
                        users.push(user);
                    });**/
							//TODO if some ingredients are loaded push them here in the manager so they are cached :)
							deferred.resolve(ingredientsArray);
						})
						.error(function(err) {
							deferred.reject(err);
						});

					return deferred.promise;
				},
				_loadAutocomplete: function(id, deferred) {
					var scope = this;

					httpAuth
						.get('/api/' + Ingredient.APIPath + '/' + id + '/?quick=true')
						.success(function(data) {
							var instance = scope._retrieveInstance(data[Ingredient.idAttribute], data);
							deferred.resolve(instance);
						})
						.error(function() {
							console.log('user collection get GOT rejected');
							deferred.reject();
						});
				},

				_measuresHaveBeenPopulated: function(instance) {
					var ans = true;
					if (instance.measures && instance.measures.length) {
						ans = !(typeof instance.measures[0] === 'string');
					}
					return ans;
				},

				getQuick: function(slug) {
					var deferred = $q.defer(),
						instance = this._search(slug);
					if (instance && this._measuresHaveBeenPopulated(instance)) {
						deferred.resolve(instance);
					} else {
						//get it from quick search
						this._loadAutocomplete(slug, deferred);
					}
					return deferred.promise;
				},

				searchAutocomplete: function(text) {
					var deferred = $q.defer();
					httpAuth
						.get('/api/ingredients/?searchAutocomplete=' + encodeURI(text))
						.success(function(ingredientsArray) {
							/**var users = []; 
                        usersArray.docs.forEach(function(userData) {
                            console.log(userData);
                            var user = scope._retrieveInstance(userData._id, userData);
                            users.push(user);
                        });**/
							//TODO if some ingredients are loaded push them here in the manager so they are cached :)
							deferred.resolve(ingredientsArray);
						})
						.error(function(err) {
							deferred.reject(err);
						});

					return deferred.promise;
				}
			},
			modelManager.init(Ingredient)
		);
	}
})();
